export default __webpack_public_path__ + "static/blog-404-blog-mobile-39ad75bc16f703d7a24b0eb4abb09ee5.png";